/* eslint-disable @typescript-eslint/no-empty-object-type */
import { DocumentData } from 'firebase/firestore';

import { EvaluationName } from './common';

export enum FirebaseFunctionEnum {
  INVOKE_SWEEPER = 'invokeSweeper',
  SUBMIT_SHORT_FORM_LEAD = 'submitShortFormLead',
  GET_IP = 'getIp_v1',
  GET_PARTNER_BY_TOKEN = 'getPartnerByToken',
  CREATE_RISK_ASSESSMENT = 'createRiskAssessment',
  POST_ENCRYPT = 'postEncrypt',
  POST_DECRYPT = 'postDecrypt',
  GET_PROGRAMS = 'getRequiredPrograms',
  BLACKLIST_EVENT = 'blacklistEvent',
  SEND_EVALUATION = 'sendEvaluation',
  GET_PERSONA = 'getPersona',
  RESOLVE_LEAD_DISTRIBUTION = 'resolveLeadDistribution',
}

export type FirebaseFunction =
  (typeof FirebaseFunctionEnum)[keyof typeof FirebaseFunctionEnum];

export interface ShortFormLeadResponse {
  Status?: 'Success' | 'Errors';
  LeadId?: string;
  LeadGUID?: string;
  APIResponse?: string;
  APIResponseType?: string;
  Errors?: string[];
  IsReentry?: boolean;
}

export interface GetPartnerByTokenRequest {
  token: string;
  requestingHost?: string;
}

export interface AxiosErrorData {
  statusCode: number;
  message: string;
  error: string;
}

export interface GetRequiredProgramsRequest {
  token: string;
}

export interface CreateRiskAssessmentRequest {
  token: string;
}

export interface GenericResponse {
  data: string;
}

export interface GetIpResponse extends GenericResponse {}

export type FirebaseCollections =
  | 'engagements'
  | 'partners'
  | 'rules'
  | 'userClaims'
  | 'userCreationRequests'
  | 'users';

export type EvaluationRule =
  | 'prequal_debt_management'
  | 'prequal_consolidation_loan'
  | 'prequal_debt_settlement'
  | 'program_options_ranking'
  | 'plan_calculator_dmp'
  | 'plan_calculator_dsp';

export enum PrequalDecisionEnum {
  QUALIFY = 'Qualify',
  DOES_NOT_QUALIFY = 'DoesNotQualify',
}

export type PrequalDecision =
  (typeof PrequalDecisionEnum)[keyof typeof PrequalDecisionEnum];

interface BaseResult<T> {
  name: EvaluationName;
  rule: EvaluationRule;
  decision: T;
  output?: Record<string, unknown>;
  programId?: string | null;
  useForProgramRanking?: boolean; // True if used for program ranking
}

export type PrequalResult = BaseResult<PrequalDecision>;
export type ProgramRankingResult = BaseResult<string>;
export type SavingsEstimateResult = BaseResult<number>;

export type EvaluationResult =
  | PrequalResult
  | ProgramRankingResult
  | SavingsEstimateResult;

export interface PrequalDetails {
  title: string;
  description: string;
  features: string[];
}

// todo: delete
export interface EvaluationCardOption {
  name: EvaluationName;
  rule: string;
  title: string;
  description: string;
  pros: string[];
  cons: string[];
  decision: PrequalDecision;
}

export interface FirebaseDocument extends DocumentData {
  id: string;
}

export interface FeatureFlags {
  [flag: string]: boolean;
}

export type IpBlacklist = {
  blacklist: string[];
};

export interface GetPersonaRequest {
  debt_amount: number;
  household_income: number;
  employment_status: string;
  hhi_consistency: string;
  credit_rating: string;
  payment_status: string;
  first_name: string;
}

export interface GetPersonaResponse {
  persona_status: string;
}
